module.exports = __webpack_public_path__ + "7336db31e4287dcebb4bdc98fa6590b7.MP3";